import React, { useState, useEffect, useCallback } from 'react';
import { Popover, message as Message } from 'antd';
import { bindActionCreators, Dispatch } from '@tkit/actions';
import { BasicModel } from '@src/services';
import { connect } from 'react-redux';
import { IRootState } from '@src/types';
import { IconFont } from '@src/features/common';
import * as models from '@services/model/models';
import { debounce } from 'lodash';
import actions from '../redux/actions';
import './Tag.less';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

const mapStateToProps = (state: IRootState) => ({
  tagListModel: state.common.tagListModel
});
interface ISProps {
  getTag: (tagList: BasicModel[]) => void;
  data: BasicModel[];
  placeholder?: React.ReactNode;
  readonly?: boolean;
}
const selctedTagListType: BasicModel[] = [];
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & ISProps;

// 输入关键字
let inputKeyWord = '';
const Tag = (props: Props) => {
  const { actions, tagListModel, getTag, readonly } = props;
  const [selctedTagList, setSelctedTagList] = useState(selctedTagListType);
  const tagListModelList = [...tagListModel];
  // 搜索
  const changeSearch = (keyWord: string) => {
    actions.getList({ params: { type: 'Tag', keyWord } });
    inputKeyWord = keyWord;
  };
  // 搜索节流
  const debounceChangeSearch = useCallback(debounce(changeSearch, 600), []);
  // tag选择
  const tagSelect = (item: BasicModel, selectedIdx: number) => {
    if (selectedIdx >= 0) {
      selctedTagList.splice(selectedIdx, 1);
    } else {
      selctedTagList.push(item);
    }
    const finalSelected = [...selctedTagList];
    setSelctedTagList(finalSelected);
    getTag(finalSelected);
  };
  // 删除tag
  const tagRemove = (index: number) => {
    const oldSelected = [...selctedTagList];
    oldSelected.splice(index, 1);
    setSelctedTagList(oldSelected);
    getTag(oldSelected);
  };
  // 初始化默认标签
  useEffect(() => {
    setSelctedTagList(props.data);
  }, [props.data]);
  // // 加载全部标签
  useEffect(() => {
    debounceChangeSearch('');
  }, [debounceChangeSearch]);
  // 添加自定义标签
  const addNewTag = () => {
    actions.addTag({
      params: {
        profile: '',
        tagName: inputKeyWord
      },
      callBack: (res: models.CommonResult) => {
        const { code, message, result } = res;
        if (code === 0) {
          selctedTagList.push({
            id: result,
            name: inputKeyWord
          });
          const finalSelected = [...selctedTagList];
          setSelctedTagList(finalSelected);
          getTag(finalSelected);
        } else {
          Message.error(message);
        }
      }
    });
  };
  // 搜索标签
  const tagSearch = () => {
    // 输入标签是否存在
    let isExit = 0;
    const keywordTagIndex = tagListModelList.findIndex(item => item.name === inputKeyWord);
    if (keywordTagIndex >= 0) {
      isExit++;
    }
    return (
      <div className="seachtag">
        <div className="seachtag-input">
          <IconFont type="icon-tag" className="icon-tag" />
          <input
            type="text"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              debounceChangeSearch(e.target.value);
            }}
          />
          <IconFont type="icon-search" className="icon-search" />
        </div>
        <div className="seachtag-content">
          {inputKeyWord.trim() && isExit === 0 && (
            <div className="option" onClick={addNewTag}>
              <IconFont type="icon-add" className="icon-add" /> 新建标签 - {inputKeyWord}
            </div>
          )}
          {tagListModelList.map(item => {
            const { id, name } = item;
            const selectedIdx = selctedTagList.findIndex(
              selectedItem => selectedItem.id === item.id
            );
            return (
              <div
                className={`option ${selectedIdx >= 0 ? 'selected' : ''}`}
                key={`tag${id}`}
                onClick={() => {
                  tagSelect(item, selectedIdx);
                }}
              >
                <IconFont type="icon-tag" className="icon-tag" />
                {name}
                {selectedIdx >= 0 && <IconFont type="icon-sure" className="icon-sure" />}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <div className="k-articles-release-tag">
      <div className="new-add-tag-box">
        {selctedTagList &&
          selctedTagList.map((item, index) => {
            return (
              <div className="tag" key={item.id}>
                <IconFont type="icon-tag" className="icon-tag" />
                {!readonly && (
                  <IconFont
                    type="icon-close"
                    className="icon-close"
                    onClick={() => {
                      tagRemove(index);
                    }}
                  />
                )}
                {item.name}
              </div>
            );
          })}
      </div>
      <div className="add-tag-box">
        {selctedTagList.length < 3 && !readonly && (
          <Popover
            placement="bottomLeft"
            content={tagSearch()}
            trigger="click"
            overlayClassName="seachtag-panel"
          >
            <div className="tags-add">
              <div className="icon-add">
                <IconFont type="icon-add" />
              </div>
              <span>添加标签</span>
            </div>
          </Popover>
        )}
      </div>

      {!selctedTagList ||
        (selctedTagList.length === 0 && (
          <p className="tag__placeholder">标签数量建议不超过3个，便于读者检索或了解文章内容</p>
        ))}
    </div>
  );
};

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Tag);
